import "devextreme/data/odata/store";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Card,
  Col,
  Container,
  Dropdown,
  Form,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import * as yup from "yup";
import { useFormik } from "formik";
import { useLocation, useParams } from "react-router-dom";
import { CustomBreadcrumbs as Breadcrumbs } from "..";
import API from "../../api/api";
import { useToast } from "../../contexts/toast";
import useFavorite from "../../hooks/useFavorite";
import { parsedUser } from "../../utils/GetCurrentUser";
import yupTypeValidator from "../../utils/YupTypeValidator";
import { exportToExcel as GenerateXLS } from "../../utils/export-to-excel";
import { exportToPDF as GeneratePDF } from "../../utils/export-to-pdf";
import Pagination from "../Pagination/Pagination";
import FieldSelector from "../customComponents/FieldSelector";
import RolesManagementFilter from "./RolesManagementFilter";
import { useTranslation } from "react-i18next";
import CustomModal from "../CustomModal/CustomModal";
import { useApiResponseHandler } from "../../hooks/useApiResponseHandler";

export default function RolesManagementContainer() {
  // PROPERTIES
  const { t } = useTranslation();
  const user = parsedUser();
  const [openDetails, setOpenDetails] = useState(null);
  const { pathname } = useLocation();
  const params = useParams();
  const { idModule } = useParams();
  const toast = useToast();
  const { handleApiResponse, ErrorModal } = useApiResponseHandler();

  const [recordCount, setRecordCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [actionMode, setActionMode] = useState(null); //I=Insert, U= Update = C= Consultar, D= Delete
  const [loading, setLoading] = useState(false);
  const [objSPVersion, setObjSPVersion] = useState(""); //This object will be used to filter the data

  const initialModel = {
    section: {},
    data: {
      Columns: [],
      Rows: [],
    },
  };
  const [section, setSection] = useState(null);
  const [fields, setFields] = useState([]);
  const [model, setModel] = useState(initialModel);
  const [currentPage, setCurrentPage] = useState(1);
  const [RecordsQuantity, setRecordsQuantity] = useState(10);
  const [selectedItem, setSelectedItem] = useState(null);
  const { isPinned, UpdateFavorites, checkIfPinned } = useFavorite();
  const selectedItemRef = useRef(null);
  const [sortBy, setSortBy] = useState("Id");
  const [sortByOrder, setSortByOrder] = useState("DESC");
  const [optionPermissions, setOptionPermissions] = useState([]);
  const [menuPermissions, setMenuPermissions] = useState([]);
  // END PROPERTIES

  //METHODS
  const toggleOpenDetails = async (item) => {
    // if (openDetails === null) {
    //   console.log("🚀 ~ toggleOpenDetails ~ item:", item)
    //   await GetOptionPermissions(item.IdAppMenu);
    //   setOpenDetails(item);
    // }
    if (openDetails && openDetails.IdAppMenu === item.IdAppMenu) {
      setOpenDetails(null);
    } else {
      await GetOptionPermissions(item);
      setOpenDetails(item);
    }
  };

  const GetOptionPermissions = async (item) => {
    try {
      console.log("🚀 ~ GetOptionPermissions ~ item:", item);
      // setLoading(true);
      const query = `IdUser=${user.IdUser}&token=${user.Token}&IdAppMenu=${item.IdAppMenu}&IdUserRole=${item.IdUserRole}`;
      const request = await API.getAction(
        "/api/Roles/CRUDcoreUserRoleDetailPermissions",
        query
      );
      let results = request.data[0];
      let parsedResults = JSON.parse(results.JSONData)[0];
      if (parsedResults && (parsedResults.Error || parsedResults.Logout || parsedResults.Expired)) {
        if (handleApiResponse(parsedResults)) {
          return;
        }
      }

      let finalResult = parsedResults.JSONData;
      const records = finalResult;
      console.log("🚀 ~ GetOptionPermissions ~ records:", records);

      if (records === null) {
        throw new Error("No data found");
      }
      setOptionPermissions(records);
    } catch (error) {
      console.log(error);
      toast({
        type: "error",
        message: error?.message || "An error occurred",
      });
    } finally {
      // setLoading(false);
    }
  };

  ///BRING THE DATA FROM THE SERVER FOR MODEL AND RECORDS
  const bindDataRemote = async (filter) => {
    setLoading(true);

    try {
      // console.log("===>", currentPage);
      let quantity = RecordsQuantity === 0 ? recordCount : RecordsQuantity;
      let query = `IdUser=${user.IdUser}&token=${user.Token}`;
      query += `&SortBy=${sortBy}&SortType=${sortByOrder}&Quantity=${quantity}&pageNumber=${currentPage}`;
      // query += "&IdBusinessUnit=" + user.IdBusinessUnit;
      let queryData = {
        Data: filter,
      };
      // console.log(query);
      let request = await API.postAction(
        `/api/Roles/RoleRecords?${query}`,
        queryData
      );
      let results = request.data[0];
      // console.log("🚀 ~ bindDataRemote ~ results:", results);
      let parsedResults = JSON.parse(results.JSONData)[0].JSONData;

      let recordResult = parsedResults;

      if (recordResult === null) {
        setModel({
          ...model,

          data: {
            ...model.data,

            Rows: [],
          },
        });

        return;
        // throw new Error("No data found");
      }

      // Migrate to the new model
      let dataFromAPI = recordResult[0]
        ? recordResult[0].JSONConfig
          ? recordResult[0].JSONData
          : recordResult
        : [];
      // console.log("Results from record", recordResult);

      //TODO: | Use JSONConfig to show specific fields
      let gridData = null;
      let gridColumns =
        dataFromAPI && dataFromAPI.length > 0
          ? Object.keys(dataFromAPI[0]).filter((x) => !x.startsWith("Id"))
          : null;

      setModel({
        ...model,

        data: {
          ...model.data,
          Columns: gridColumns,
          Rows: gridData || dataFromAPI,
        },
      });

      await bindDataCountRemote();

      // setData(recordResult)
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const [features, setFeatures] = useState([]);
  const bindDataFeaturesRemote = async (filter) => {
    setLoading(true);

    try {
      // console.log("===>", currentPage);
      if (selectedItem === null) return;

      let query = `IdUser=${user.IdUser}&token=${user.Token}&GUIDUserRole=${selectedItem.GUID}`;

      // console.log(query);
      let request = await API.getAction(
        "/api/Roles/CRUDcoreUserRoleDetails?" + query
      );
      let results = request.data[0];

      let parsedResults = JSON.parse(results.JSONData)[0].JSONData;
      // console.log("features", parsedResults);
      let recordResult = parsedResults;

      if (recordResult !== null) {
        // console.log("o.o es que devuelve null?");
        setFeatures(recordResult);

        return;
        // throw new Error("No data found");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const bindDataPermissions = async (item) => {
    setLoading(true);

    try {
      // console.log("===>", currentPage);
      if (selectedItem === null) return;

      let query = `IdUser=${user.IdUser}&token=${user.Token}&GUIDUserRole=${selectedItem.GUID}`;

      // console.log(query);
      let request = await API.getAction(
        "/api/Roles/CRUDcoreUserRoleDetailsPermissions?" + query
      );
      let results = request.data[0];

      let parsedResults = JSON.parse(results.JSONData)[0].JSONData;
      // console.log("features", parsedResults);
      let recordResult = parsedResults;

      if (recordResult !== null) {
        setFeatures(recordResult);

        return;
        // throw new Error("No data found");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setTableHeader([]);
    bindDataRemote(objSPVersion);
    setSelectedItem(null);
  }, [params.id, idModule]);

  useEffect(() => {
    bindDataRemote(objSPVersion);
    setSelectedItem(null);
  }, [currentPage]);

  const bindDataCountRemote = async (cleanFilter) => {
    // First start loading the model

    try {
      let query = `IdUser=${user.IdUser}&token=${user.Token}${
        idModule ? "&IdModule=" + idModule : ""
      }`;

      query = query + `&Quantity=${RecordsQuantity}&pageNumber=${currentPage}`;

      let queryData = {
        Data: "",
      };

      let request = await API.postAction(
        `api/Roles/RoleCount?${query}`,
        queryData
      );

      let results = request.data[0];
      let parsedResults = JSON.parse(results.JSONData)[0];
      setRecordCount(parsedResults.JSONData.Count);
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const bindDataModelRemote = async (cleanFilter) => {
    try {
      //Now let's load sections
      let querySections = `IdUser=${user.IdUser}&token=${user.Token}${
        idModule ? "&IdModule=" + idModule : ""
      }`;
      let requestSections = await API.getAction(
        `/api/Roles/RoleModel`,
        querySections
      );
      let resultsSections = requestSections.data[0];
      let parsedResultsSections = JSON.parse(resultsSections.JSONData)[0];
      if (parsedResultsSections && (parsedResultsSections.Error || parsedResultsSections.Logout || parsedResultsSections.Expired)) {
        if (handleApiResponse(parsedResultsSections)) {
          return;
        }
      }

      let recordResultSection = parsedResultsSections.JSONData;

      //! If grid data stays null, we use the data from the API

      // Solo filtramos el separador de auditoría, no los campos individuales
      let titles = [
        "Informacion de auditoria",
        "Audit Information",
      ];
      console.log("🚀 ~ bindDataModelRemote ~ recordResultSection:", recordResultSection);
      setSection(recordResultSection[0]);
      let fields = recordResultSection[0].Fields.filter(
        (item) => !titles.includes(item.FieldTitle)
      );
      setFields(fields);

      //Now try to fill the filters
      let fieldsFilter = fields.filter((x) => x.isFilter === true);
      // setFilters(fieldsFilter);
      console.log("🚀 ~ bindDataModelRemote ~ fieldsFilter:", fieldsFilter);
    } catch (error) {
      console.error(error);
    } finally {
      //  setLoading(false);
    }
  };

  const [tableHeader, setTableHeader] = useState([]);
  const [formSize, setFormSize] = useState('lg');

  const bindDataHeaderRemote = async (cleanFilter) => {
    try {
      //Now let's load sections
      let querySections = `IdUser=${user.IdUser}&token=${user.Token}${
        idModule ? "&IdModule=" + idModule : ""
      }`;
      let requestSections = await API.getAction(
        `api/Roles/RolesHeader`,
        querySections
      );
      // console.log("Header", requestSections);
      let resultsSections = requestSections.data[0];
      let parsedResultsSections = JSON.parse(resultsSections.JSONData)[0];
      // console.log("Header 2", parsedResultsSections);
      if (parsedResultsSections && (parsedResultsSections.Error || parsedResultsSections.Logout || parsedResultsSections.Expired)) {
        if (handleApiResponse(parsedResultsSections)) {
          return;
        }
      }

      let recordResultSection = parsedResultsSections.JSONData;
      console.log("🚀 ~ bindDataHeaderRemote ~ recordResultSection:", recordResultSection);
      
      // Establecer el tamaño del formulario desde el API
      setFormSize(recordResultSection[0].FormSize ?? 'lg');

      //! If grid data stays null, we use the data from the API

      setTableHeader(recordResultSection[0].Fields);
    } catch (error) {
      console.error(error);
    } finally {
      //  setLoading(false);
    }
  };

  const bindDataDetailsRemote = async (recordId) => {
    //First load records
    try {
      let query = `IdUser=${user.IdUser}&token=${
        user.Token
      }&RecordId=${recordId}${idModule ? "&IdModule=" + idModule : ""}`;
      let request = await API.getAction(`api/Roles/RoleDetails`, query);
      let results = request.data[0];
      // console.log("🚀 ~ bindDataDetailsRemote ~ results:", results);

      let parsedResults = JSON.parse(results.JSONData)[0];
      if (parsedResults && (parsedResults.Error || parsedResults.Logout || parsedResults.Expired)) {
        if (handleApiResponse(parsedResults)) {
          return;
        }
      }

      let finalResult = parsedResults.JSONData;
      fillFormikObject(finalResult);
      // No establecer selectedItem a null aquí, lo necesitamos para los features
      // bindDataFeaturesRemote necesita selectedItem.GUID
      setSelectedItem(finalResult);
      bindDataFeaturesRemote();
    } catch (error) {
      console.error(error);
    }
    //Fill object with new values
  };

  //Open edit/add mode
  const toggleOpen = async (action, reload) => {
    setActionMode(action);

    if (action === null) {
      setSelectedItem(null);
      setFeatures([]);
      formik.resetForm();
      setOpen(false);
      if (reload) {
        bindDataRemote(objSPVersion);
      }
      return;
    }

    if (action === "I") {
      setSelectedItem(null);
      setFeatures([]);
      formik.resetForm();
      setOpen(true);
    }
    
    if (action === "U" || action === "C" || action === "D") {
      await bindDataDetailsRemote(selectedItem.GUID);
      setOpen(true);
    }

    if (selectedItemRef.current) {
      selectedItemRef.current.clearSelection();
    }
  };

  //Delete the record
  const deleteConfirm = async (obj) => {
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <CustomModal
            type="error"
            title="¡Confirmar Acción!"
            message="¿Está seguro que desea eliminar este registro?"
            primaryButtonText="Eliminar"
            secondaryButtonText="Cancelar"
            onPrimaryClick={async () => {
              try {
                setLoading(true);
                
                let query = `IdUser=${user.IdUser}&token=${user.Token}&RecordId=${
                  selectedItem.GUID
                }${idModule ? "&IdModule=" + idModule : ""}`;
                
                let response = await API.getAction(`api/Roles/RoleDelete`, query);
                
                setLoading(false);
                onClose(); // Cerrar modal de confirmación
                
                // Mostrar modal de éxito
                confirmAlert({
                  closeOnClickOutside: false,
                  customUI: ({ onClose: onCloseSuccess }) => {
                    return (
                      <CustomModal
                        type="success"
                        title="¡Acción Completada!"
                        message="Tu solicitud se ha procesado correctamente."
                        secondaryMessage="El registro se eliminó exitosamente."
                        primaryButtonText="Continuar"
                        onPrimaryClick={() => {
                          onCloseSuccess();
                          // Recargar la tabla y limpiar selección
                          bindDataRemote(objSPVersion);
                          setSelectedItem(null);
                        }}
                        onClose={onCloseSuccess}
                      />
                    );
                  }
                });
              } catch (error) {
                console.error("Error al eliminar:", error);
                setLoading(false);
                onClose();
                toast({
                  type: "error",
                  message: "Error al eliminar el registro: " + (error.message || "Desconocido"),
                });
              }
            }}
            onSecondaryClick={() => {
              onClose();
            }}
          />
        );
      },
    });
  };

  //Update the field value on formik according to what has been updated
  const updateField = (fieldName, fieldValue) => {
    formik.setFieldValue(fieldName, fieldValue);
  };

  const [validationsSchema, setValidationSchema] = useState(null);

  const fillFormikObject = (record) => {
    // console.log("record", record, "model", section);
    if (section && fields && fields.length > 0) {
      fields.forEach((item) => {
        if (item && item.FieldName.length > 0) {
          // console.log(
          //   "field name",
          //   item.FieldName,
          //   "RecordValue ",
          //   record[item.FieldName]
          // );
          formik.setFieldValue(item.FieldName, record[item.FieldName]);
        }
      });
      // bindDataFeaturesRemote();
    }

    //Now
  };

  const prepareFormikObject = () => {
    // console.log("Preparing formik object", section);
    let initialObject = {};
    let initialObjectValidation = {};

    if (fields) {
      fields.forEach((item) => {
        // Usar DefaultValue si existe, sino usar cadena vacía o valor apropiado según el tipo
        initialObject[item.FieldName] = item.DefaultValue || 
          (item.FieldType === "bit" || item.FieldType === "bool" ? false : "");

        if (item.Required) {
          initialObjectValidation[item.FieldName] = yupTypeValidator(item);
        }
      });
    }
    formik.initialValues = initialObject;

    setValidationSchema(yup.object(initialObjectValidation));
    //Now
  };

  //This method is to save the record we are working on
  const handleSubmit = async (obj, event) => {
    console.log("🚀 ~ handleSubmit ~ obj:", obj);
    console.log("🚀 ~ handleSubmit ~ formik.values:", formik.values);
    
    // Capturar los valores actuales antes del confirmAlert para evitar problemas de closure
    const currentActionMode = actionMode;
    const currentFields = [...fields];
    const currentFormikValues = { ...formik.values };
    let currentObj = { ...obj };
    
    let actions = {
      I: "I",
      U: "U",
      D: "I",
    };

    if (currentActionMode === "D") {
      const { GUID, Id, ...rest } = currentObj;
      currentObj = rest;
    }

    const mensajeConfirmacion = "¿Confirma que desea guardar este registro?";

    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <CustomModal
            type="confirm"
            title="¡Confirmar Acción!"
            message={mensajeConfirmacion}
            primaryButtonText="Confirmar"
            secondaryButtonText="Cancelar"
            onPrimaryClick={async () => {
              try {
                setLoading(true);
                
                console.log("🚀 ~ fields a procesar:", currentFields);
                console.log("🚀 ~ currentObj:", currentObj);
                console.log("🚀 ~ currentActionMode:", currentActionMode);
                
                let objSPVersion = "";
                
                // Si es modo UPDATE, agregar el GUID primero
                if (currentActionMode === "U" && currentObj.GUID) {
                  objSPVersion = `@GUID='${currentObj.GUID}'`;
                  console.log("✅ Agregando GUID para UPDATE:", currentObj.GUID);
                }
                
                currentFields.forEach((item) => {
                  // Excluir campos ReadOnly, separators, y campos de eliminación
                  if (item.ReadOnly || item.HtmlType === "separator") return;
                  if (item.FieldName === "IdUserDel" || item.FieldName === "DateDel") return;
                  // No incluir GUID nuevamente si ya se agregó
                  if (item.FieldName === "GUID") return;
                  
                  console.log(`✅ Procesando campo: ${item.FieldName}, Valor: ${currentObj[item.FieldName]}`);

                  if (item.HtmlType !== "separator") {
                    objSPVersion +=
                      (objSPVersion.length > 0 ? ", " : "") + `@${item.FieldName}=`;
                  }
                  if (
                    item.FieldType === "int" ||
                    item.FieldType === "bool" ||
                    item.FieldType === "bit" ||
                    item.FieldType === "bigint"
                  ) {
                    objSPVersion +=
                      currentObj[item.FieldName] === undefined || currentObj[item.FieldName] === null
                        ? item.DefaultValue && item.DefaultValue.length > 0
                          ? item.DefaultValue
                          : "null"
                        : "'" + currentObj[item.FieldName] + "'";
                  } else if (item.HtmlType === "radio") {
                    objSPVersion +=
                      currentObj[item.FieldName] === undefined || currentObj[item.FieldName] === null
                        ? item.DefaultValue && item.DefaultValue.length > 0
                          ? item.DefaultValue
                          : "null"
                        : "'" + currentObj[item.FieldName] + "'";
                  } else {
                    objSPVersion +=
                      currentObj[item.FieldName] === undefined || currentObj[item.FieldName] === null
                        ? "null"
                        : "'" + currentObj[item.FieldName] + "'";
                  }
                });

                console.log("🚀 ~ objSPVersion:", objSPVersion);
                
                let queryString = `IdUser=${user.IdUser}&Token=${user.Token}&ActionMode=${
                  actions[currentActionMode]
                }${idModule ? "&IdModule=" + idModule : ""}`;
                let queryData = {
                  Data: objSPVersion,
                };
                
                console.log("🚀 ~ queryString:", queryString);
                console.log("🚀 ~ queryData:", queryData);
                
                let request = await API.postAction(
                  `api/Roles/RoleAddEdit?${queryString}`,
                  queryData
                );

                console.log("🚀 ~ request:", request);

                if (request.status === 200) {
                  let response = JSON.parse(request.data[0].JSONData)[0];
                  console.log("🚀 ~ response completa:", response);
                  console.log("🚀 ~ response.JSONData:", response.JSONData);
                  console.log("🚀 ~ response.Error:", response.Error);
                  
                  if (response && (response.Error || response.Logout || response.Expired)) {
                    setLoading(false);
                    console.error("❌ Error del servidor:", response.Msg);
                    if (handleApiResponse(response)) {
                      onClose();
                      return;
                    }
                  }

                   // Si es modo INSERT y JSONData es null, mostrar modal de éxito
                   if (currentActionMode === "I" && !response.JSONData) {
                     setLoading(false);
                     onClose(); // Cerrar modal de confirmación
                     
                     // Mostrar modal de éxito
                     confirmAlert({
                       closeOnClickOutside: false,
                       customUI: ({ onClose: onCloseSuccess }) => {
                         return (
                           <CustomModal
                             type="success"
                             title="¡Acción Completada!"
                             message="Tu solicitud se ha procesado correctamente."
                             secondaryMessage="El registro se guardó exitosamente."
                             primaryButtonText="Continuar"
                             onPrimaryClick={() => {
                               onCloseSuccess();
                               toggleOpen(null, true); // Cerrar formulario y recargar
                             }}
                             onClose={onCloseSuccess}
                           />
                         );
                       }
                     });
                     return;
                   }

                  // Si hay JSONData, procesarlo normalmente
                  if (response.JSONData) {
                    // Actualizar el item seleccionado y el formulario
                    setSelectedItem(response.JSONData);
                    fillFormikObject(response.JSONData);

                     if (currentActionMode === "I") {
                       // Modo INSERT: Mostrar modal de éxito y cerrar todo
                       setLoading(false);
                       onClose(); // Cerrar el modal de confirmación
                       
                       // Mostrar modal de éxito
                       confirmAlert({
                         closeOnClickOutside: false,
                         customUI: ({ onClose: onCloseSuccess }) => {
                           return (
                             <CustomModal
                               type="success"
                               title="¡Acción Completada!"
                               message="Tu solicitud se ha procesado correctamente."
                               secondaryMessage="El registro se guardó exitosamente."
                               primaryButtonText="Continuar"
                               onPrimaryClick={() => {
                                 onCloseSuccess();
                                 toggleOpen(null, true); // Cerrar formulario y recargar
                               }}
                               onClose={onCloseSuccess}
                             />
                           );
                         }
                       });
                     } else {
                       // Modo UPDATE o DUPLICATE: Mostrar modal de éxito
                       if (currentActionMode === "D") {
                         // Duplicar el rol
                         console.log("🚀 ~ Duplicando rol con:", {
                           Id: response.JSONData.Id,
                           GUID: response.JSONData.GUID,
                           previousGUID: currentFormikValues.GUID
                         });
                         
                         await API.getAction(
                           `api/Roles/Duplicate`,
                           `IdUser=${user.IdUser}&token=${user.Token}&RecordId=${response.JSONData.Id}&GUID=${response.JSONData.GUID}&previousRecord=${currentFormikValues.GUID}`
                         );
                       }

                       setLoading(false);
                       onClose(); // Cerrar el modal de confirmación
                       
                       // Mostrar modal de éxito
                       confirmAlert({
                         closeOnClickOutside: false,
                         customUI: ({ onClose: onCloseSuccess }) => {
                           return (
                             <CustomModal
                               type="success"
                               title="¡Acción Completada!"
                               message="Tu solicitud se ha procesado correctamente."
                               secondaryMessage={currentActionMode === "D" ? "El registro se duplicó exitosamente." : "El registro se actualizó exitosamente."}
                               primaryButtonText="Continuar"
                               onPrimaryClick={() => {
                                 onCloseSuccess();
                                 toggleOpen(null, true); // Cerrar formulario y recargar datos
                               }}
                               onClose={onCloseSuccess}
                             />
                           );
                         }
                       });
                     }
                  } else {
                    // Si no hay JSONData en modo UPDATE/DUPLICATE, mostrar modal de éxito
                    setLoading(false);
                    onClose(); // Cerrar el modal de confirmación
                    
                    // Mostrar modal de éxito
                    confirmAlert({
                      closeOnClickOutside: false,
                      customUI: ({ onClose: onCloseSuccess }) => {
                        return (
                          <CustomModal
                            type="success"
                            title="¡Acción Completada!"
                            message="Tu solicitud se ha procesado correctamente."
                            secondaryMessage={currentActionMode === "D" ? "El registro se duplicó exitosamente." : "El registro se actualizó exitosamente."}
                            primaryButtonText="Continuar"
                            onPrimaryClick={() => {
                              onCloseSuccess();
                              toggleOpen(null, true); // Cerrar formulario y recargar datos
                            }}
                            onClose={onCloseSuccess}
                          />
                        );
                      }
                    });
                  }
                }
              } catch (e) {
                console.error("❌ Error en handleSubmit:", e);
                console.error("❌ Error stack:", e.stack);
                setLoading(false);
                toast({
                  type: "error",
                  message: `Error al guardar el registro: ${e.message || e}`,
                });
                onClose();
              }
            }}
            onSecondaryClick={() => {
              onClose();
            }}
          />
        );
      },
    });
  };

  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,

    validateOnChange: false,
    validateOnBlur: false,

    validationSchema: validationsSchema,
    onSubmit: handleSubmit,
  });

  const addFavorite = async () => {
    const newFavorite = {
      icon: `${section.FormIcon}`,
      path: pathname,
      formPath: section.FormPath,
      title: section.FormTitle,
    };
    UpdateFavorites(newFavorite);
  };

  const headerWithoutAuditFields = () => {
    return (
      tableHeader &&
      tableHeader.filter(
        (x) =>
          x.FieldTitle !== "Audit Information" &&
          x.FieldName !== "Id" &&
          x.FieldName !== "IdUserAdd" &&
          x.FieldName !== "DateAdd" &&
          x.FieldName !== "IdUserMod" &&
          x.FieldName !== "DateMod"
      )
    );
  };

  const exportToExcel = useCallback(async () => {
    GenerateXLS(model.data.Rows, `${section.FormTitle}.xlsx`);
  }, [model.data.Rows]);

  const exportToPDF = useCallback(async () => {
    const container = document.getElementById("contentContainer");
    GeneratePDF(container);
  }, []);

  const updateFeature = async (item, apply) => {
    // console.log(item, apply, selectedItem);
    if (formik.values === null) return;

    let query = `IdUser=${user.IdUser}&token=${user.Token}`;
    let queryData = {
      Data: `@Accion = 'U', @IdAppMenu=${item.IdAppMenu}, @GUIDUserRole='${formik.values.GUID}', @Apply=${apply}`,
    };

    await API.postAction(
      "/api/Roles/CRUDcoreUserRoleDetailsAddEdit?" + query,
      queryData
    );
    let f = features.map((x) => {
      if (x.IdAppMenu === item.IdAppMenu) {
        x.Apply = apply;
      }
      return x;
    });
    // f.filter((x) => x.IdRoomFeature === item.IdRoomFeature)[0].Apply = apply;

    setFeatures(f);
  };

  const updateSubFeature = async (item, apply, parent) => {
    // console.log(item, apply, selectedItem);
    //if (formik.values === null) return;
    // [core].[spCRUDcoreUserRoleDetailPermissions]
    // @Accion  = 'U'
    // ,@Apply bit = 0
    // ,@GUID uniqueidentifier = null
    // ,@IdActiveUser bigint
    // ,@Token        int = null
    let query = `IdUser=${user.IdUser}&token=${user.Token}`;

    let queryData = {
      Data: `@IdUserRoleDetail=${parent.Id},@IdAppMenuPermission=${item.IdAppMenuPermission}, @GUID='${item.GUID}', @Apply=${apply}`,
    };

    await API.postAction(
      "/api/Roles/MenuPermissionsAddEdit?" + query,
      queryData
    );
    debugger;
    let f = optionPermissions.map((x) => {
      if (x.IdAppMenu === item.IdAppMenu && x.Id === item.Id) {
        x.Apply = apply;
      }
      return x;
    });
    // f.filter((x) => x.IdRoomFeature === item.IdRoomFeature)[0].Apply = apply;

    setOptionPermissions(f);
  };
  // END METHODS

  // UI METHODS

  useEffect(() => {
    bindDataRemote(objSPVersion);
  }, [sortBy, sortByOrder]);

  const handleFilter = async (obj) => {
    setObjSPVersion(obj);
    await bindDataRemote(obj);
  };

  const loadGRIDUI = () => {
    return (
      <>

  
        <Container>
          {/*

          <RolesManagementFilter
            handleFilter={handleFilter}
            count={recordCount}
            isLoading={loading}
          />

           */}
           
          <Card>
            <Card.Body>
              <Row>
                <div className="table-responsive">
                  <Table
                    hover
                    size="xl"
                    bordered
                    className="table table-bordered shadow-sm table-striped"
                  >
                    <thead>
                      <tr>
                        {headerWithoutAuditFields().map((item, index) => {
                          // console.log(item);
                          return (
                            <th
                              key={index}
                              className={`fw-bold clickable`}
                              onClick={() => {
                                // console.log(item, sortBy, sortByOrder)
                                setSortBy(item.FieldName);
                                if (item.FieldName === sortBy) {
                                  if (sortByOrder === "ASC") {
                                    setSortByOrder("DESC");
                                  } else {
                                    setSortByOrder("ASC");
                                  }
                                } else {
                                  setSortByOrder("ASC");
                                }
                              }}
                            >
                              {item.FieldTitle}{" "}
                              {sortBy === item.FieldName &&
                              sortByOrder === "ASC" ? (
                                <i className="fas fa-sort-up"></i>
                              ) : sortBy === item.FieldName &&
                                sortByOrder === "DESC" ? (
                                <i className="fas fa-sort-down"></i>
                              ) : null}{" "}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {model?.data &&
                        model.data.Rows.map((item, index) => {
                          // console.log("item", item, "header", tableHeader);
                          return (
                            <tr
                              key={index}
                              onClick={() => {
                                setSelectedItem(item);
                              }}
                              style={{ cursor: "pointer" }}
                              className={
                                selectedItem && selectedItem.GUID === item.GUID
                                  ? "active"
                                  : ""
                              }
                            >
                              {headerWithoutAuditFields().map(
                                (column, index2) => {
                                  return (
                                    <td key={index2} className={` `}>
                                      {typeof item[column.FieldName] ===
                                      "boolean" ? (
                                        <input
                                          type="checkbox"
                                          checked={item[column.FieldName]}
                                          className=""
                                          readOnly
                                        />
                                      ) : (
                                        item[column.FieldName]
                                      )}
                                    </td>
                                  );
                                }
                              )}
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </div>
                <Pagination
                  RecordsQuantity={RecordsQuantity}
                  currentPage={currentPage}
                  isLoading={loading}
                  recordCount={recordCount}
                  setCurrentPage={setCurrentPage}
                  setRecordsQuantity={setRecordsQuantity}
                  // totalPages={totalPages}
                />
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </>
    );
  };

  //EVENTS

  useEffect(() => {
    setOpen(false);
    setSelectedItem(null);
    setActionMode(null);
    setModel(initialModel);
    checkIfPinned();
    bindDataModelRemote();
    bindDataHeaderRemote();
    //bindDataRemote();

    return () => formik.resetForm();
  }, [params.id]);

  useEffect(() => {
    // console.log("section updated", model);
    prepareFormikObject();
  }, [section, fields]);

  useEffect(() => {
    // console.log("entro record quantity");
    bindDataRemote(objSPVersion);
  }, [RecordsQuantity]);

  useEffect(() => {
    if (open) {
      //Search features
      if (selectedItem) {
        // bindDataFeaturesRemote();
      }
    }
  }, [open, selectedItem]);

  // END EVENTS

  // Renderizar ErrorModal incluso si section es null
  if (!section) {
    return <ErrorModal />;
  }
  
  return (
    <React.Fragment>
      {open ? (
        <Modal
          show={open}
          onHide={() => toggleOpen(null)}
          backdrop="static"
          keyboard={false}
          size={formSize === 'lg' ? 'xl' : formSize}
          className={"modalRight " + formSize}
        >
          <Modal.Header closeButton style={{ backgroundColor: "#D7DEE5" }}>
            <Modal.Title>{section.FormTitle}</Modal.Title>
          </Modal.Header>
          <Form onSubmit={formik.handleSubmit}>
            <Modal.Body>
              <Row>
                <Col>
                  <Row>
                    {fields.map((item, index) => {
                      // Excluir campos de eliminación
                      if (item.FieldName === "IdUserDel" || item.FieldName === "DateDel") {
                        return null;
                      }
                      
                      // Detectar si este es el primer campo de auditoría para agregar separador ANTES
                      const isFirstAuditField = item.FieldName === "IdUserAdd";
                      
                      return (
                        <React.Fragment key={index}>
                          {/* Agregar separador ANTES del primer campo de auditoría */}
                          {isFirstAuditField && (
                            <Col className="col-12 col-md-12">
                              <label className="me-2 mt-4 pt-4 separatorTitle">
                                Información de Auditoría
                              </label>
                              <br />
                              <hr className="separatorLine" />
                            </Col>
                          )}
                          
                          <Col
                            className={
                              item.cssClasss + 
                              // Mostrar todos los campos excepto los que tienen HtmlType "hidden"
                              (item.HtmlType === "hidden" ? " d-none" : "")
                            }
                          >
                            <label
                              className={
                                item.HtmlType === "separator"
                                  ? `me-2 ${
                                      index !== 0 ? "mt-4 pt-4" : "mt-2"
                                    }  separatorTitle`
                                  : "me-2 mt-3 "
                              }
                            >
                              {item.FieldTitle}
                              {item.Required ? (
                                <i className="required-asterisk ms-1 text-danger">
                                  *
                                </i>
                              ) : null}
                            </label>
                            <br />

                            <FieldSelector
                              actionMode={actionMode}
                              model={item}
                              obj={formik.values}
                              updateField={updateField}
                              value={formik.values[item.FieldName]}
                            ></FieldSelector>
                            {formik.errors[item.FieldName] ? (
                              <div className="invalid text-sm">
                                {formik.errors[item.FieldName]}
                              </div>
                            ) : null}
                          </Col>
                        </React.Fragment>
                      );
                    })}
                  </Row>
                </Col>
                <Col className="border-left">
                  {/* TABS */}
                  <Row>
                    <Col>
                      <Card>
                        <Card.Body>
                          <Table striped bordered>
                            <thead>
                              <tr>
                                {/*
                                
                                <th></th>
                                */}
                                <th>Opción</th>
                                <th>Permiso</th>
                              </tr>
                            </thead>
                            <tbody>
                              {features &&
                                features.map((item, index) => {
                                  // console.log("🚀 ~ features.map ~ item:", item)
                                  if (index === 0) {
                                    // console.log(actionMode, item);
                                  }
                                  return (
                                    <>
                                      <tr key={`${index} - ${item.IdAppMenu}`}>
                                          {/*
                                          
                                        <td>
                                          <button
                                            type="button"
                                            className="btn btn-sm"
                                            disabled={loading}
                                            onClick={() =>
                                              toggleOpenDetails(item)
                                            }
                                          >
                                            {openDetails &&
                                            openDetails.IdAppMenu ===
                                              item.IdAppMenu ? (
                                              <i className="fa fa-chevron-down"></i>
                                            ) : (
                                              <i className="fa fa-chevron-right"></i>
                                            )}
                                          </button>
                                        </td>
                                          */}
                                        <td>{`${item.OptionMenuLevel1} > ${item.OptionMenuLevel2} > ${item.OptionMenuLevel3}`}</td>
                                        <td>
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={item.Apply}
                                              disabled={actionMode === "C"}
                                              onChange={(e) => {
                                                // console.log(e.target.checked);
                                                updateFeature(
                                                  item,
                                                  e.target.checked
                                                );
                                              }}
                                              name="Status"
                                              // onBlur={handleBlur}
                                            />
                                          </div>
                                          {item.Applied}
                                        </td>
                                      </tr>
                                      {openDetails &&
                                        openDetails.IdAppMenu ===
                                          item.IdAppMenu && (
                                          <tr>
                                            <td colSpan={3}>
                                              <Card className="bg-light">
                                                <Card.Header>
                                                  {t("Permissions")}
                                                </Card.Header>
                                                <Card.Body>
                                                  <Row>
                                                    <Col>
                                                      <table className="table table-bordered shadow-sm table-striped">
                                                        <thead>
                                                          <tr>
                                                            <th>
                                                              {t("Options")}
                                                            </th>
                                                            <th className="text-center">
                                                              {t("Apply")}
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {optionPermissions &&
                                                            optionPermissions.map(
                                                              (
                                                                subitem,
                                                                subindex
                                                              ) => {
                                                                return (
                                                                  <tr
                                                                    key={
                                                                      subindex
                                                                    }
                                                                  >
                                                                    <td>
                                                                      {
                                                                        subitem.Description
                                                                      }
                                                                    </td>
                                                                    <td className="text-center">
                                                                      <div className="form-check form-switch">
                                                                        <input
                                                                          className="form-check-input"
                                                                          type="checkbox"
                                                                          checked={
                                                                            subitem.Apply
                                                                          }
                                                                          disabled={
                                                                            actionMode ===
                                                                            "C"
                                                                          }
                                                                          onChange={(
                                                                            e
                                                                          ) => {
                                                                            // console.log(e.target.checked);
                                                                            updateSubFeature(
                                                                              subitem,
                                                                              e
                                                                                .target
                                                                                .checked,
                                                                              item
                                                                            );
                                                                          }}
                                                                          name="Status"
                                                                          // onBlur={handleBlur}
                                                                        />
                                                                      </div>
                                                                    </td>
                                                                  </tr>
                                                                );
                                                              }
                                                            )}
                                                        </tbody>
                                                      </table>
                                                    </Col>
                                                  </Row>
                                                </Card.Body>
                                              </Card>
                                            </td>
                                          </tr>
                                        )}
                                    </>
                                  );
                                })}
                            </tbody>
                          </Table>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#D7DEE5" }}>
              <div className="d-flex gx-3 align-items-center justify-content-end">
                {Object.values(formik.errors).length > 0 && (
                  <span className="invalid me-2">
                    Por favor, verificar los errores en el formulario
                  </span>
                )}
                <button
                  className={`btn ${actionMode === "C" ? "btn-primary" : "btn-cancel-hover"} me-2`}
                  type="button"
                  onClick={() => toggleOpen(null)}
                  style={{ width: "155px", height: "40px" }}
                >
                  {actionMode === "C" ? "Cerrar" : "Cancelar"}
                </button>
                {actionMode !== "C" && (
                  <button
                    className="btn btn-success"
                    type="button"
                    disabled={loading}
                    onClick={() => [formik.submitForm()]}
                    style={{ width: "155px", height: "40px" }}
                  >
                    Guardar
                  </button>
                )}
              </div>
            </Modal.Footer>
          </Form>
        </Modal>
      ) : null}
      {section?.FormPath && <Breadcrumbs pathTitle={section?.FormPath} />}
      <Container>
        <div className="row mx-0">
          <div className="col-12">
            <div className="d-flex flex-wrap align-items-center justify-content-between mb-2 mt-2">
              <React.Fragment>
                <div className="d-flex align-items-center my-1">
                  <i className={section.FormIcon + " me-3 fa-2x"}></i>
                  <div className="d-flex flex-column">
                    <h5 className={"my-1"}>{section.FormTitle}</h5>
                  </div>
                </div>
              </React.Fragment>
              {loading ? (
                <React.Fragment>
                  <div className="">
                    <div
                      className="w-25 mx-auto my-1"
                      style={{ paddingTop: "" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : null}
              <div className="w-auto d-flex align-items-center">
                {actionMode === null ? (
                  <>
                    <button
                      className="btn btn-sm btn-primary my-1 me-2"
                      title="Create"
                      disabled={loading}
                      onClick={() => toggleOpen("I")}
                    >
                      <i className="fa fa-plus"></i>
                    </button>
                  </>
                ) : null}
                {selectedItem ? (
                  <>
                    <button
                      className="btn btn-sm  my-1 me-2"
                      title="Update"
                      disabled={loading}
                      onClick={() => toggleOpen("U")}
                      aria
                    >
                      <i className="fa fa-pencil"></i>
                    </button>
                    <button
                      className="btn btn-sm  my-1 me-2"
                      title="View"
                      disabled={loading}
                      onClick={() => toggleOpen("C")}
                    >
                      <i className="fa fa-eye"></i>
                    </button>
                  </>
                ) : null}

                <Dropdown>
                  <Dropdown.Toggle variant="button" id="dropdown-basic">
                    <i className="fa fa-ellipsis-v" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {isPinned ? (
                      <Dropdown.Item
                        onClick={() => {
                          addFavorite();
                        }}
                      >
                        Remover de favoritos
                      </Dropdown.Item>
                    ) : (
                      <Dropdown.Item
                        onClick={() => {
                          addFavorite();
                        }}
                      >
                        Agregar a favoritos
                      </Dropdown.Item>
                    )}
                    <Dropdown.Divider />
                    {selectedItem ? (
                      <Dropdown.Item
                        onClick={() => {
                          toggleOpen("D");
                        }}
                      >
                        Duplicar
                      </Dropdown.Item>
                    ) : null}

                    {actionMode === null ? (
                      <Dropdown.Item
                        onClick={() => {
                          exportToExcel();
                        }}
                      >
                        Exportar a Excel
                      </Dropdown.Item>
                    ) : null}
                    {actionMode === "C" ? (
                      <Dropdown.Item onClick={() => exportToPDF()}>
                        Export a PDF
                      </Dropdown.Item>
                    ) : null}

                    <Dropdown.Divider />
                    {selectedItem ? (
                      <Dropdown.Item onClick={() => deleteConfirm()}>
                        Eliminar
                      </Dropdown.Item>
                    ) : null}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            {loadGRIDUI()}
          </div>
        </div>
      </Container>

      {/* Modal de error de la API */}
      <ErrorModal />
    </React.Fragment>
  );
}